import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <div class="branding">
      <a *ngIf="!isVendor" href="/">
        <img
          src="./assets/images/logos/studioip logo black.png"
          width="150" height="35"
          class="align-middle m-2"
          alt="logo"
        />
      </a>
      <a *ngIf="isVendor" href="/workspace/vendor/dashboard">
        <img
          src="./assets/images/logos/studioip logo black.png"
          width="150" height="35"
          class="align-middle m-2"
          alt="logo"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent {
  @Input() visibility: string = '';
@Input() isVendor: boolean = false;
  constructor() {}
}
